import { useNotifier } from "@shared/components/providers/notifier-context"
import type { CardAttrsBase } from "@shared/unified-tiptap/util/card"
import { getCardTitle } from "@shared/unified-tiptap/util/card"
import { findNodeAndPos } from "@shared/unified-tiptap/util/descendant-helpers"
import type { Editor } from "@tiptap/core"
import { useUiContext } from "../../unified-tiptap-ui-context"

/**
 * Stores a composed comment against the card `getCardId` names.
 */
export function useSubmitCardComment(
  editor: Editor,
  getCardId: () => string | null,
): (commentText: string) => void {
  const {
    commentActions: { addComment },
  } = useUiContext()
  const notify = useNotifier()

  return (commentText: string) => {
    const cardId = getCardId()
    const card =
      cardId === null
        ? null
        : findNodeAndPos(
            editor.state.doc,
            (node) => node.type.isInGroup("card") && (node.attrs as CardAttrsBase).id === cardId,
          )
    // The card can go away while the composer is open, and the comment has nothing to hang on
    // without it.
    if (cardId === null || !card) {
      notify("warning", "Sorry, you can't add a comment here!")
      return
    }
    addComment(cardId, getCardTitle(card.node), commentText)
  }
}
